<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('scope.service.complete') }}</div>
    <div slot="body">
      <dialog-selected-tips :name="params.data[0].type === 'consulting' ? $t('scope.technical_consulting') : $t('scope.remote_assistance')" :count="params.data.length" :action="$t('scope.service.complete')" />
      <dialog-table :data="params.data" :columns="columns" />
      <a-form-model :model="form" :rules="rules" ref="form" v-bind="formItemLayout">
        <a-form-model-item :label="$t('scope.service.complete.score')" prop="score">
          <a-rate v-model="form.score" :count="5" />
        </a-form-model-item>
        <a-form-model-item :label="$t('scope.service.complete.feedback')" prop="feedback">
          <a-input v-model="form.feedback" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'SaasTechSupportCompleteDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      form: {
        score: 0,
        feedback: '',
      },
      rules: {
        score: [
          { required: true, message: this.$t('common.tips.input', [this.$t('scope.service.complete.score')]) },
          { type: 'number', min: 1, message: '请至少选择1星' },
        ],
        feedback: [
          { required: true, message: this.$t('common.tips.input', [this.$t('scope.service.complete.feedback')]) },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    columns () {
      const showFields = ['name', 'status', 'created_at']
      return this.params.columns.filter((item) => { return showFields.includes(item.field) })
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        await this.params.onManager('performAction', {
          id: this.params.data[0].id,
          managerArgs: {
            action: 'complete',
            data: {
              score: this.form.score,
              feedback: this.form.feedback,
            },
          },
        })
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
